<p-dialog
  #dashboardFiltros
  [modal]="true"
  [visible]="true"
  (visibleChange)="matDialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <span class="fs-normal font-bold text-center m-3">
      Filtros avançados
    </span>
  </ng-template>
  <div class="row">
    <div class="mt-2 flex align-items-center field datePicker col-md-3">
      <p-floatLabel class="width-100">
        <p-calendar
          style="width: 100%;"
          dateMask
          placeholder="Faixa de datas"
          selectionMode="range"
          [formControl]="keywordFormDateRange"
          dateFormat="dd/mm/yy"
          [maxDate]="maxDate"
          [minDate]="minDateField"
          [showIcon]="true"
          [readonlyInput]="true"
          inputId="range"
          appendTo="body"
        >
        </p-calendar>
        <label for="data_hora">Faixa de datas</label>
      </p-floatLabel>
    </div>
    <fast-autocomplete
      #input
      id="field-linha-montagem"
      placeholder="Linha de montagem"
      class="col-md-9 mt-2"
      [domain_id]="domainId"
      displayField="descricao"
      [value_order]="'descricao'"
      [autoFirst]="false"
      [pageValue]="'0'"
      [pageSizeValue]="'10'"
      (selectEntity)="fillLinhaValue($event)"
      [control]="linhaProducaoControl"
      (clearSelection)="clearFilterLinha()"
      [entityService]="linhaProducaoService"
      [actionState]="false"
      [initDataWithEmpty]="true"
      [messages]="{
        typeIs: 'Valor inválido',
        isEmptyValue: 'Inválido: remova os espaços em branco!'
      }"
    ></fast-autocomplete>
    <fast-autocomplete
      #input
      id="field-modelo"
      placeholder="Modelo"
      class="col-md-12 mt-2"
      [readonly]="!linhaProdId"
      [valueSearchField]="linhaProdId"
      [searchFieldPath]="'linha_producao_id'"
      [domain_id]="domainId"
      [useChange]="true"
      [autoFirst]="false"
      displayField="descricao"
      [value_order]="'descricao'"
      [pageValue]="'0'"
      [pageSizeValue]="'10'"
      [control]="modeloControl"
      (clearSelection)="modeloControl.reset()"
      [entityService]="modeloService"
      [actionState]="false"
      [initDataWithEmpty]="true"
      [messages]="{
        typeIs: 'Valor inválido',
        isEmptyValue: 'Inválido: remova os espaços em branco!'
      }"
    ></fast-autocomplete>
    <fast-autocomplete
      #input
      id="field-cliente"
      placeholder="Cliente"
      class="col-md-12 mt-2"
      [domain_id]="domainId"
      [autoFirst]="false"
      displayField="nome_razao_social"
      [value_order]="'pre_cadastro.nome_razao_social'"
      [pageValue]="'0'"
      [pageSizeValue]="'10'"
      [control]="preCadastroControl"
      (clearSelection)="preCadastroControl.reset()"
      [entityService]="preCadastroService"
      [actionState]="false"
      [initDataWithEmpty]="true"
      [messages]="{
        typeIs: 'Valor inválido',
        isEmptyValue: 'Inválido: remova os espaços em branco!'
      }"
    ></fast-autocomplete>
    <fast-autocomplete
      #input
      id="field-vendedor"
      placeholder="Vendedor"
      class="col-md-12 mt-2"
      [domain_id]="domainId"
      [autoFirst]="false"
      [displayWithEntityFn]="displayVendedor"
      displayField="parceiro.apelido_nome_fantasia"
      [domainPath]="'parceiro.domain_id'"
      [value_order]="'parceiro.apelido_nome_fantasia'"
      [pageValue]="'0'"
      [pageSizeValue]="'10'"
      [include]="['parceiro']"
      [control]="vendedorControl"
      (clearSelection)="vendedorControl.reset()"
      [entityService]="vendedorService"
      [actionState]="false"
      [initDataWithEmpty]="true"
      [messages]="{
        typeIs: 'Valor inválido',
        isEmptyValue: 'Inválido: remova os espaços em branco!'
      }"
    ></fast-autocomplete>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex align-items-center justify-content-between width-100 mb-3">
      <button
        class="mt-2"
        pButton
        pButtonRipple
        icon="pi pi-times-circle"
        (click)="matDialogRef.close({ clear: true })"
        iconPos="right"
        text
        rounded
        [disabled]="disableClearFilter"
        severity="danger"
        label="Limpar filtros"
      ></button>
      <button
        pButton
        pButtonRipple
        icon="pi pi-check-circle"
        iconPos="right"
        outlined
        rounded
        [disabled]="disableApplyFilter"
        severity="primary"
        (click)="matDialogRef.close({
          'linhaProducaoControl': linhaProducaoControl,
          'modeloControl': modeloControl,
          'preCadastroControl': preCadastroControl,
          'vendedorControl': vendedorControl,
          'keywordFormDateRange': keywordFormDateRange,
          'keywordFormDateRangeStart': keywordFormDateRangeStart,
          'keywordFormDateRangeEnd': keywordFormDateRangeEnd,
        })"
        label="Aplicar filtros"
      ></button>
    </div>
  </ng-template>
</p-dialog>
